export const getInitiatedByDescription = (initiatedBy?: string | null): string => {
    switch (initiatedBy) {
        case 'POM4':
            return 'Alert started from the POM Mobile';
        case 'POM4APP':
            return 'Alert started from POM Mobile to the Mobile App';
        case 'POM3':
            return 'Alert started from the POM3';
        case 'app':
        case 'APP':
        case 'AppInitiated':
            return 'Alert started from the Mobile App';
        default:
            return 'No Information Available';
    }
};
